export { default as logo } from "assets/img/momeento.png";
export { default as playstoreBtn } from "assets/img/googleplaystore.png";
export { default as appleBtn } from "assets/img/appstore.png";
export { default as iPhone } from "assets/img/mobile.png";
export { default as googleSvg } from "assets/svg-icons/google.svg";
export { default as avatar } from "assets/img/avatars/jenna.png";
export { default as friendAvatar } from "assets/img/avatars/dan.jpg";
export { default as friendAvatar2 } from "assets/img/demo/users/bobby.jpg";
export { default as friendAvatar3 } from "assets/img/demo/users/michael.jpg";
export { default as friendAvatar4 } from "assets/img/demo/users/rolf.jpg";
export { default as placeholder } from "assets/img/placeholder.png";
export { default as addFeedImg } from "assets/img/addFeed.png";
export { default as postKey } from "assets/img/postkey.png";
export { default as profileBG } from "assets/img/profileBG.png";
export { default as notFoundSvg } from "assets/img/not-found.svg";

import screenshot1 from "assets/img/screen_shots/00.png";
import screenshot2 from "assets/img/screen_shots/02.jpeg";
import screenshot3 from "assets/img/screen_shots/03.jpeg";
import screenshot4 from "assets/img/screen_shots/04.jpeg";
import screenshot5 from "assets/img/screen_shots/05.jpeg";

export const loginScreenshots = [
    screenshot1,
    screenshot2,
    screenshot3,
    screenshot4,
    screenshot5
];

// demo communities
import demo01 from "assets/img/demo/communities/1.jpeg";
import demo02 from "assets/img/demo/communities/2.jpeg";
import demo03 from "assets/img/demo/communities/3.jpeg";
import demo04 from "assets/img/demo/communities/4.jpg";
import demo05 from "assets/img/demo/communities/5.jpeg";
import demo06 from "assets/img/demo/communities/6.jpeg";
import demo07 from "assets/img/demo/communities/7.jpeg";
import demo08 from "assets/img/demo/communities/8.jpeg";
import demo09 from "assets/img/demo/communities/9.jpeg";
import demo10 from "assets/img/demo/communities/10.jpeg";
import demo11 from "assets/img/demo/communities/11.jpeg";
import demo12 from "assets/img/demo/communities/12.jpeg";
import demo13 from "assets/img/demo/communities/13.jpg";
import demo14 from "assets/img/demo/communities/14.jpeg";
import demo15 from "assets/img/demo/communities/15.jpeg";
import demo16 from "assets/img/demo/communities/16.jpeg";
import demo17 from "assets/img/demo/communities/17.jpeg";
import demo18 from "assets/img/demo/communities/18.jpeg";
import demo19 from "assets/img/demo/communities/19.jpeg";
import demo20 from "assets/img/demo/communities/20.jpeg";

export const demoCommunityListingImg = [
    demo01,
    demo02,
    demo03,
    demo04,
    demo05,
    demo06,
    demo07,
    demo08,
    demo09,
    demo10,
    demo11,
    demo12,
    demo13,
    demo14,
    demo15,
    demo16,
    demo17,
    demo18,
    demo19,
    demo20
];
